import { IModuleListDescriptionAction } from "./moduleListDescriptionAction";
import { IModuleDescription, IModuleSubDescription } from "./moduleListDescriptionInterface";


const listDefault: (IModuleSubDescription | IModuleDescription)[] = []

function moduleListDescriptionReducer(
    state: (IModuleSubDescription | IModuleDescription)[] = listDefault,
    action: IModuleListDescriptionAction
): (IModuleSubDescription | IModuleDescription)[] {

    switch (action.type) {
        case "UPDATE_MODE_LIST_DESCRIPTION":
            return action.payload;
        case "PROGRESS_CLEAR":
            return listDefault;
        default:
            return state;
    }
}

export default moduleListDescriptionReducer;